import { z } from "zod";
import { nameRegex, phoneRegex, zipCodeRegex } from "./validationRegex";
import { SALUTATION } from "@/types";
export const validationSchema = (t, displayOwnerFlag, customFields, phoneNumberRequired, isMessageRequired, isPrivateOwner, isSuggestPriceForm = false) => {
    const baseShema = z.object({
        salutation: z.nativeEnum(SALUTATION, {
            errorMap: () => {
                return { message: t("contact.form.salutation_error_empty") };
            },
        }),
        firstName: z
            .string({
            invalid_type_error: t("contact.form.firstname_error_empty"),
        })
            .trim()
            .min(2, {
            message: t("contact.form.firstname_error_empty"),
        })
            .regex(nameRegex, {
            message: t("contact.form.firstname_error_invalid"),
        }),
        lastName: z
            .string({
            invalid_type_error: t("contact.form.lastname_error_empty"),
        })
            .trim()
            .min(2, {
            message: t("contact.form.lastname_error_empty"),
        })
            .regex(nameRegex, {
            message: t("contact.form.lastname_error_invalid"),
        }),
        email: z
            .string({ invalid_type_error: t("contact.form.email_error_empty") })
            .min(1, {
            message: t("contact.form.email_error_empty"),
        })
            .email({
            message: t("contact.form.email_error_invalid"),
        }),
        phoneNumber: phoneNumberRequired
            ? z
                .string({ invalid_type_error: t("contact.form.phone_error_invalid") })
                .trim()
                .min(1, {
                message: t("contact.form.phone_error_empty"),
            })
                .regex(phoneRegex, {
                message: t("contact.form.phone_error_invalid"),
            })
            : z
                .string({ invalid_type_error: t("contact.form.phone_error_invalid") })
                .trim()
                .min(2, {
                message: t("contact.form.phone_error_invalid"),
            })
                .regex(phoneRegex, {
                message: t("contact.form.phone_error_invalid"),
            })
                .nullish()
                .or(z.literal("")),
        message: isMessageRequired && isPrivateOwner
            ? z
                .string()
                .min(10, {
                message: t("contact.form.subject_error_empty"),
            })
                .max(2500, {
                message: t("contact.form.subject_error_length"),
            })
            : z.string().max(2500, {
                message: t("contact.form.subject_error_length"),
            }),
        isOwner: displayOwnerFlag ? z.boolean() : z.void(),
        shareSeekerProfile: z.boolean().optional(),
        shouldOptOutSavedSearch: z.boolean().optional(),
        offerOptin: z.boolean().optional(),
        newsletterOptout: z.boolean().optional(),
        newsletterOptInPreference: z
            .string()
            .min(1, { message: t("contact.form.opt_in_out_value_error_empty") })
            .optional(),
        street: customFields
            ? z
                .string({
                invalid_type_error: t("contact.form.street_error_empty"),
            })
                .min(5, { message: t("contact.form.street_error_empty") })
                .max(160, { message: t("contact.form.street_error_empty") })
            : z.string().nullish(),
        city: customFields
            ? z
                .string({
                invalid_type_error: t("contact.form.city_error_empty"),
            })
                .min(2, { message: t("contact.form.city_error_empty") })
                .regex(nameRegex, {
                message: t("contact.form.city_error_empty"),
            })
                .max(80, { message: t("contact.form.city_error_empty") })
            : z.string().nullish(),
        zipCode: customFields
            ? z
                .string({
                invalid_type_error: t("contact.form.zip_error_empty"),
            })
                .regex(zipCodeRegex, {
                message: t("contact.form.zip_error_empty"),
            })
                .min(2, { message: t("contact.form.zip_error_empty") })
                .max(10, { message: t("contact.form.zip_error_empty") })
            : z.string().nullish(),
    });
    if (isSuggestPriceForm) {
        return baseShema.extend({
            suggestPrice: z
                .string({
                invalid_type_error: t("contact.form.suggest_price.error_empty"),
                required_error: t("contact.form.suggest_price.error_empty"),
            })
                .min(1, { message: t("contact.form.suggest_price.error_empty") })
                .max(160, { message: t("contact.form.suggest_price.error_empty") }),
        });
    }
    return baseShema;
};
